import { useEffect, useState } from 'react';

import { Socket } from 'socket.io-client';

import { useAppSelector } from 'hooks';
import {
  getAuthorizedSubgroups,
  getCurrentGroup,
  selectCurrentGid,
  selectGroups
} from 'store/groups/reducer';
import { isOrganization } from 'utils/Groups';

interface IUseNotificationsProps {
  type: 'alerts' | 'messages' | 'report';
  matchUid?: boolean;
}

const useNotifications = ({ type, matchUid = false }: IUseNotificationsProps) => {
  const socket = useAppSelector(({ notifications }) => notifications.socket) as Socket;
  const groups = useAppSelector(selectGroups);
  const selectedGid = useAppSelector(selectCurrentGid);
  const patient = useAppSelector(({ patient }) => patient.data);
  const [lastMessage, setLastMessage] = useState<INotificationsAlerts | null>(null);
  const subgroupsIds = useAppSelector(getAuthorizedSubgroups).map((x) => x.gid);
  const currentGroup = useAppSelector(getCurrentGroup);
  const currentGroupIsOrganization = currentGroup && isOrganization(currentGroup);

  useEffect(() => {
    const handleNotification = (event: INotificationsAlerts) => {
      if (matchUid && patient?.uid !== event.uid) {
        return false;
      }
      if (
        selectedGid === event.gid ||
        (currentGroupIsOrganization && [selectedGid, ...subgroupsIds].includes(event.gid)) ||
        (selectedGid === 'all' && groups.map((x) => x.gid).includes(event.gid))
      )
        return setLastMessage(event);
    };
    if (socket) {
      socket.on(type, handleNotification);
    }

    return () => {
      socket && socket.off(type, handleNotification);
    };
  }, [
    socket,
    selectedGid,
    groups,
    type,
    patient,
    matchUid,
    subgroupsIds,
    currentGroupIsOrganization
  ]);

  return { lastMessage };
};

export default useNotifications;
